import { Plus } from "lucide-react";
import { t } from "i18next";
import MicrophoneIcon from "@/assets/mic.svg";
import HandshakeIcon from "@/assets/heart-handshake.svg";
import EducateIcon from "@/assets/educate.svg";
import { SubscriptionOnlyButton } from "../SubscriptionOnlyButton/SubscriptionOnlyButton";
import { ValidationSuscriptionButton } from "@/common/enums/enums";

interface EmptyStateProps {
  onOpenSidebar: () => void;
}

export function EmptyVisits({ onOpenSidebar }: EmptyStateProps): JSX.Element {
  const bulletPoints = [
    {
      text: t("visits.emptyState.microphone"),
      icon: MicrophoneIcon,
    },
    {
      text: t("visits.emptyState.consent"),
      icon: HandshakeIcon,
    },
    {
      text: t("visits.emptyState.educate"),
      icon: EducateIcon,
    },
  ];

  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh]">
      <div className="w-3/5">
        <p className="text-primary mb-8 font-light">
          {t("visits.emptyState.beforeWeStart")}
        </p>
        {bulletPoints.map((item, index) => (
          <p key={index} className="flex text-left mb-8 self-center font-light">
            <span className="mr-4 inline-block">
              <img alt="microphone-icon" className="h-6 w-6" src={item.icon} />
            </span>
            {item.text}
          </p>
        ))}
      </div>
      <SubscriptionOnlyButton
        className="uppercase tracking-widest"
        validations={[ValidationSuscriptionButton.RECORDING_USAGES]}
        onClick={onOpenSidebar}
      >
        <Plus className="w-5 h-5 mr-0.5" />
        {t("visits.newVisitButton")}
      </SubscriptionOnlyButton>
    </div>
  );
}
